const postService = {
  /**
   * Fetches paginated posts from the API
   * @param {string} accessToken - The authentication token
   * @param {number} page - The page number to fetch
   * @param {string} apiUrl - Base API URL
   * @returns {Promise<{posts: Array, totalPages: number, currentPage: number}>} The posts data and pagination info
   */
  async fetchPosts(accessToken, page = 1, apiUrl) {
    try {
      // if (!accessToken) {
      //   throw new Error('Authentication token is required');
      // }

      const response = await fetch(`${apiUrl}posts/list/?page=${page}`, {
        // headers: {
        //   Authorization: `Bearer ${accessToken}`,
        //   "Content-Type": "application/json",
        // },
      });

      // Handle HTTP errors
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Failed to fetch posts: ${response.status}`);
      }

      const data = await response.json();
      console.log('Data is : ', data);
      return {
        posts: data.results || [],
        totalPages: data.count || 1,
        currentPage: data.currentPage || page
      };
    } catch (error) {
      console.error('Error fetching posts:', error);
      throw error;
    }
  }
};

export default postService;
